<template>
<div class="container text-center">
  <div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">{{$t('Données personnelles')}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="password-tab" data-bs-toggle="tab" data-bs-target="#password" type="button" role="tab" aria-controls="password" aria-selected="false">{{$t('Mot de passe')}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="affiliated-tab" data-bs-toggle="tab" data-bs-target="#affiliated" type="button" role="tab" aria-controls="affiliated" aria-selected="false">{{$t('Comptes affiliés')}}</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="orders-tab" data-bs-toggle="tab" data-bs-target="#orders" type="button" role="tab" aria-controls="orders" aria-selected="false">{{$t('Mes commandes')}}</button>
    </li>
    </ul>
  </div>
  <br>
  <div class="tab-content" id="myTabContent">
    <address-manager :cur-user="curUser" @logout="logout" @modify-user="modifyUser" ></address-manager>
    <modify-password></modify-password>
    <comptes-affilies :curUser="curUser"></comptes-affilies>
    <my-orders :curUser="curUser"></my-orders>
  </div>
</div>
</template>

<script>
import ModifyPassword from '@/components/ModifyPassword.vue'
import AddressManager from '@/components/AddressManager.vue'
import ComptesAffilies from '@/components/ComptesAffilies.vue'
import MyOrders from '@/components/MyOrders.vue'

export default {
  components: { ModifyPassword, AddressManager, ComptesAffilies, MyOrders},
  props: ['curUser'],
  setup(props, context) {
    const getUser = function() {
      return this.curUser;
    }
    const modifyUser = function (user) {
      console.log(user);
    }
    const logout = function(user) {
      context.emit("connect", user);
    }
   return {
     logout,
     modifyUser,
     getUser
   }
  }
}

</script>
<style scoped>
</style>